import React from "react";


const VerifyIcon = props => {

    return (
        <svg id="Verify-icon" data-name="Verify-icon" xmlns="http://www.w3.org/2000/svg" width="24.99" height="24.99" viewBox="0 0 24.99 24.99">
            <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(0)" fill="#fff" stroke="#00c102" stroke-width="2">
                <circle cx="12.495" cy="12.495" r="12.495" stroke="none" />
                <circle cx="12.495" cy="12.495" r="11.495" fill="none" />
            </g>
            <path id="Path_1" data-name="Path 1" d="M163.392,326.973l3.316,3.316,6.67-6.67" transform="translate(-156.077 -314.102)" fill="none" stroke="#00c102" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
        </svg>
    );

}

export default VerifyIcon;